// @generated by protobuf-ts 2.9.4 with parameter long_type_string,generate_dependencies
// @generated from protobuf file "audio_format.proto" (package "speaker.beta2", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * *
 * The audio format that is used for the transmitted audio.
 *
 * @generated from protobuf message speaker.beta2.AudioFormat
 */
export interface AudioFormat {
  /**
   * @generated from protobuf field: speaker.beta2.AudioFormat.Encoding encoding = 1;
   */
  encoding: AudioFormat_Encoding; // Provided or requested audio encoding
  /**
   * @generated from protobuf field: uint32 samplerate = 2;
   */
  samplerate: number; // Normally set to the provided/ requested sample rate. Ignored for provided WAV e.g. to the ASR (the samplerate is then signalled within the WAV file)
  /**
   * @generated from protobuf field: uint32 bitrate = 3;
   */
  bitrate: number; // Used for audio encoding LC3plus, ignored otherwise
}
/**
 * *
 * This field describes the encoding of the incoming or outgoing audio data for the respective request.
 *
 * @generated from protobuf enum speaker.beta2.AudioFormat.Encoding
 */
export enum AudioFormat_Encoding {
  /**
   * Field not set
   *
   * @generated from protobuf enum value: AUDIO_FORMAT_UNSPECIFIED = 0;
   */
  AUDIO_FORMAT_UNSPECIFIED = 0,
  /**
   * Raw audio data stream as signed 16-bit integer, little endian
   *
   * @generated from protobuf enum value: PCM16 = 1;
   */
  PCM16 = 1,
  /**
   * RIFF WAVE
   *
   * @generated from protobuf enum value: WAV = 2;
   */
  WAV = 2,
  /**
   * Free Lossless Audio Codec (https://xiph.org/flac/)
   *
   * @generated from protobuf enum value: FLAC = 3;
   */
  FLAC = 3,
  /**
   * LC3plus codec
   *
   * @generated from protobuf enum value: LC3PLUS = 4;
   */
  LC3PLUS = 4,
}
// @generated message type with reflection information, may provide speed optimized methods
class AudioFormat$Type extends MessageType<AudioFormat> {
  constructor() {
    super("speaker.beta2.AudioFormat", [
      {
        no: 1,
        name: "encoding",
        kind: "enum",
        T: () => ["speaker.beta2.AudioFormat.Encoding", AudioFormat_Encoding],
      },
      {
        no: 2,
        name: "samplerate",
        kind: "scalar",
        T: 13 /*ScalarType.UINT32*/,
      },
      { no: 3, name: "bitrate", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
    ]);
  }
  create(value?: PartialMessage<AudioFormat>): AudioFormat {
    const message = globalThis.Object.create(this.messagePrototype!);
    message.encoding = 0;
    message.samplerate = 0;
    message.bitrate = 0;
    if (value !== undefined)
      reflectionMergePartial<AudioFormat>(this, message, value);
    return message;
  }
  internalBinaryRead(
    reader: IBinaryReader,
    length: number,
    options: BinaryReadOptions,
    target?: AudioFormat
  ): AudioFormat {
    let message = target ?? this.create(),
      end = reader.pos + length;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case /* speaker.beta2.AudioFormat.Encoding encoding */ 1:
          message.encoding = reader.int32();
          break;
        case /* uint32 samplerate */ 2:
          message.samplerate = reader.uint32();
          break;
        case /* uint32 bitrate */ 3:
          message.bitrate = reader.uint32();
          break;
        default:
          let u = options.readUnknownField;
          if (u === "throw")
            throw new globalThis.Error(
              `Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`
            );
          let d = reader.skip(wireType);
          if (u !== false)
            (u === true ? UnknownFieldHandler.onRead : u)(
              this.typeName,
              message,
              fieldNo,
              wireType,
              d
            );
      }
    }
    return message;
  }
  internalBinaryWrite(
    message: AudioFormat,
    writer: IBinaryWriter,
    options: BinaryWriteOptions
  ): IBinaryWriter {
    /* speaker.beta2.AudioFormat.Encoding encoding = 1; */
    if (message.encoding !== 0)
      writer.tag(1, WireType.Varint).int32(message.encoding);
    /* uint32 samplerate = 2; */
    if (message.samplerate !== 0)
      writer.tag(2, WireType.Varint).uint32(message.samplerate);
    /* uint32 bitrate = 3; */
    if (message.bitrate !== 0)
      writer.tag(3, WireType.Varint).uint32(message.bitrate);
    let u = options.writeUnknownFields;
    if (u !== false)
      (u == true ? UnknownFieldHandler.onWrite : u)(
        this.typeName,
        message,
        writer
      );
    return writer;
  }
}
/**
 * @generated MessageType for protobuf message speaker.beta2.AudioFormat
 */
export const AudioFormat = new AudioFormat$Type();
